import { useContext } from 'react';

import { GRID_CELL_SIZE } from '../../design-styles/grid/grid-cell/GRID_CELL_SIZE';
import { GridCellContext } from '../../design-styles/grid/grid-cell/GridCellProvider';
import { IResponsive } from '../../shared/types/IResponsive';

import { PRODUCT_CARD_SIZES } from './PRODUCT_CARD_SIZES';

export function useResponsiveProductCardSizes (): IResponsive<PRODUCT_CARD_SIZES> {
    const gridCellContext: IResponsive<GRID_CELL_SIZE> = useContext(GridCellContext);

    const size: IResponsive<PRODUCT_CARD_SIZES> = {
        sm: PRODUCT_CARD_SIZES.DEFAULT,
        md: PRODUCT_CARD_SIZES.DEFAULT,
        lg: PRODUCT_CARD_SIZES.DEFAULT,
    };

    if (gridCellContext?.sm === GRID_CELL_SIZE.COLUMN_3) {
        size.sm = PRODUCT_CARD_SIZES.EXTRA_SMALL;
    }

    if (gridCellContext?.md === GRID_CELL_SIZE.COLUMN_3) {
        size.md = PRODUCT_CARD_SIZES.EXTRA_SMALL;
    }

    if (gridCellContext?.lg === GRID_CELL_SIZE.COLUMN_3) {
        size.lg = PRODUCT_CARD_SIZES.EXTRA_SMALL;
    }

    return size;
}
